import React from 'react';
import BankConnections from '../components/BankConnections';

const BankConnectionsPage: React.FC = () => {
  return (
    <div className="page">
      <div className="page-header">
        <h1>🏦 Bank Connections</h1>
        <p>Connect your bank accounts to automatically track your net worth</p>
      </div>
      
      <BankConnections />
    </div>
  );
};

export default BankConnectionsPage; 